jQuery(function ($) {
    document.querySelectorAll('.frm_opt_container input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', function () {
            const questionContainer = this.closest('.frm_form_field');
            const questionText = questionContainer.querySelector('.frm_primary_label');

            // Check if the radio button value is "No" and apply the red color
            if (this.value.toLowerCase() === 'gold') {
                questionText.classList.add('gold-text');
            } else {
                questionText.classList.remove('gold-text');
            }
        });
    });

});